import React from 'react';

const ChildTask = ({ item, moveChildTask, highlightClass }) => {
    const isUnread = item?.Email?.messageRead === 'unread' || item?.subEmail?.messageRead === 'unread';
    const displayTitle = item?.title || item?.subject || item?.Email?.subject || "(No Title)";

    return (
        <div className="">
            <div className="grid-disp">
                <h3 
                    className={`title-box ${isUnread ? 'font-bold' : highlightClass}`}
                    title={displayTitle}
                >
                    {displayTitle}
                </h3>
                
                <div className="date-align">
                    {isUnread && <div className="unread-red-dot"></div>}
                    <span data-no-popup>
                        <img alt="Remove" src="assets/popout.svg" onClick={() => moveChildTask(item, '', true)} />
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ChildTask;
